import { render, staticRenderFns } from "./TournamentHistory.vue?vue&type=template&id=c90050ac&"
import script from "./TournamentHistory.vue?vue&type=script&lang=js&"
export * from "./TournamentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports